<template>
  <div>
    <div style="padding:0.2rem;background-color:bisque;box-shadow: 0 15px 10px;">
      <div style="text-align:center">
        <el-tooltip class="item" effect="dark" content="点击查看大图" placement="top">
          <el-image :preview-src-list="[itemList.url]" :src="itemList.url"
            style="cursor: pointer;with:1rem;height:3rem">
          </el-image>
        </el-tooltip>
      </div>
      <p style="text-align:center;margin-top:0.2rem">
        <el-tooltip class="item" effect="dark" :content="itemList.name" placement="top">
          <span
            style="display: block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size:medium;font-weight:bold">{{ itemList.name }}</span>
        </el-tooltip>
      </p>
      <div style="text-align:center;margin-top:0.2rem">
        <el-checkbox v-model="checkedItem" :true-label="JSON.stringify({id:itemList.id,checked:1})"
          :false-label="JSON.stringify({id:itemList.id,checked:2})"
          :label="itemList.checked === 1 ? '已选中' : '选择'" @change="setChoosed"
          :disabled="itemList.checked === 1"></el-checkbox>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PictureItem',
  props: ['itemList'],
  data() {
    return {
      checkedItem: this.itemList.checked === 1 ? true : false,
    }
  },
  methods: {
    setChoosed(val) {
      this.$axios
        .put('api/ysy_common_set_checked', {
          val,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
          this.$bus.$emit('ysy_pictureItem_refresh')
        })
        .catch()
    },
  },
  watch: {
    itemList(n) {
      this.checkedItem = n.checked === 1 ? true : false
    },
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/PictureCom/PictureItem.vue